import React from 'react'
import {ClientLayout} from './layouts/ClientLayout'
import { Navigation } from './routes'
import {AuthProvider} from './context'
import { SnackbarProvider } from 'notistack'
import 'react-toastify/dist/ReactToastify.css';
import './responsive.css';
import { ToastContainer } from 'react-toastify';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';


export default function App() {
  return (
    <AuthProvider>

        <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        autoHideDuration={3000}
        >

        <Navigation />

      </SnackbarProvider>  
      <ToastContainer />
    </AuthProvider>

  )
}
